import { memo } from '@morphic-ts/common/es6/utils';
import * as t from 'io-ts';
import { IOTSType, IoTsURI } from '../hkt';
import { iotsApplyConfig } from './../config';
/**
 *  @since 0.0.1
 */
export const ioTsIntersectionInterpreter = memo(() => ({
    _F: IoTsURI,
    intersection: (...items) => (name, config) => env => {
        const codecs = items.map(x => x(env).type);
        return new IOTSType(iotsApplyConfig(config)(t.intersection(codecs, name), env, { codecs }));
    }
}));
